import  { joinURL  } from 'ufo';

export function useCountryPath( inputPath, viaProxy = false ) {

  const runtimeConfig = useRuntimeConfig()

  const {$i18n} = useNuxtApp();

  const basePath = joinURL(runtimeConfig.public.proxyURL, $i18n.locale.value)

  const path = joinURL(basePath, inputPath)
  return path
}


export function useBackendPath( inputPath, viaProxy = false ) {

  const runtimeConfig = useRuntimeConfig()

  const {$i18n} = useNuxtApp();

  const basePath = joinURL(runtimeConfig.public.backendURL, $i18n.locale.value)

  const path = joinURL(basePath, inputPath)
  return path
}